export default __webpack_public_path__ + "static/inline-edit-do-065829b7a891c48af1c098b0cd5ebfd86f716430a606b0480b3cbab83746842a.png";